export default __webpack_public_path__ + "static/media/logo.4e06d1a1.svg";